// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CookieConsentController from "./cookieconsent_controller"
application.register("cookieconsent", CookieConsentController)

import MapController from "./map_controller"
application.register("map", MapController)

import LatLonController from "./latlon_controller"
application.register("latlon", LatLonController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import ActiveStorageController from "./activestorage_controller"
application.register("activestorage", ActiveStorageController)

import MobileLinkController from "./mobilelink_controller"
application.register("mobilelink", MobileLinkController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)
